/**
 *
 * ListTree
 *
 */

import React, { Fragment } from "react"
import { Spin, Checkbox } from "antd"
import FlechaSVG from "../../images/iconoFlecha.svg"
import "./index.less"

/* eslint-disable react/prefer-stateless-function */
class ListTree extends React.Component {
  state = { columns: [{ name: "Dimensiones" }] }

  setStateFrom = (values) => {
    this.setState(values)
  }

  renderRow = (e, i, isChild = false) => {
    if (e.dimension_name === "Engagement") return
    const {
      openDimensions,
      showCheckbox,
      selectedDimension,
      valueChecked,
    } = this.props

    return (
      <Fragment key={`${i}-2`}>
        <div
          key={i}
          className={`ListTreeComponent-table-body-row  ${
            e.is_long
              ? "ListTreeComponent-table-body-rowQuestion"
              : isChild
              ? "ListTreeComponent-table-body-rowChild"
              : ""
          }`}>
          <div
            className="ListTreeComponent-table-body-row-description"
            style={{ paddingLeft: e.level * (showCheckbox ? 18 : 14) }}>
            {showCheckbox && !e.is_long && e.level === 1 ? (
              <Checkbox
                checked={selectedDimension.includes(e[valueChecked])}
                onChange={() => this.props.onSelectDimension(e)}>
                {e.dimension_name}
              </Checkbox>
            ) : (
              <span
                style={{
                  padding: 0,
                  display: "inline",
                  color: "#4F4F4F",
                  cursor: "default",
                }}>
                {e.dimension_name}
              </span>
            )}
          </div>
          <div className="ListTreeComponent-table-body-row-description text-center">
            {e.childs && e.childs.length > 0 ? (
              openDimensions.includes(e.id_dimension) ? (
                <img
                  src={FlechaSVG}
                  onClick={() => this.props.clickDimension(e)}
                  style={{ cursor: "pointer", transform: "rotate(90deg)" }}
                />
              ) : (
                <img
                  src={FlechaSVG}
                  onClick={() => this.props.clickDimension(e)}
                  style={{ cursor: "pointer", transform: "rotate(-180deg)" }}
                />
              )
            ) : null}
          </div>
        </div>

        {e.childs &&
          openDimensions.includes(e.id_dimension) &&
          e.childs.map((c, i) => this.renderRow(c, i, true))}
      </Fragment>
    )
  }

  render() {
    const { data, isLoading, hideHeaders } = this.props
    const { columns } = this.state

    return (
      <div className="ListTreeComponent">
        <div className="ListTreeComponent-table">
          <div className="ListTreeComponent-table-body ListTreeComponent-table-body-header">
            <div className="ListTreeComponent-table-body-row">
              {columns.map((item, i) => {
                return (
                  <div
                    key={i}
                    className="ListTreeComponent-table-body-row-title">
                    {!hideHeaders.includes(i) && item.name}
                  </div>
                )
              })}
            </div>
          </div>
          {isLoading ? (
            <div className="ListTreeComponent-table-body-loading">
              <Spin size="large" />
            </div>
          ) : (
            <div className="ListTreeComponent-table-body">
              {data && data.map((e, i) => this.renderRow(e, i))}
            </div>
          )}
        </div>
      </div>
    )
  }
}

ListTree.propTypes = {}
ListTree.defaultProps = {
  hideHeaders: [],
  valueChecked: "id",
  onSelectDimension: () => {},
  selectedDimension: [],
  showColumnImpact: false, // mostrar columna impacto
}
export default ListTree
